/* eslint-disable @typescript-eslint/no-unused-vars */
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Adherence, CSR, DataProvided, Employment, Holding, IllegalPayments, Next, OccurringEmp, Prev, PrideRepute, PubIntrest, QualityOriented, Representation, Safe, Security, Standards } from "../../../common/svg/AllSvg";
import Slider from "react-slick";


const DrivesUs = () => {
    const { t } = useTranslation('common');
    const arrowRef: any = useRef(null);
    const [newIdx, setNewIdx] = useState(1);
    const data: any[] = [
        { name: t("corporate.content_pages.about_us.our_values.public_interest.title"), desc: t("corporate.content_pages.about_us.our_values.public_interest.desc"), icon: PubIntrest },
        { name: t("corporate.content_pages.about_us.our_values.emp_disparity.title"), desc: t("corporate.content_pages.about_us.our_values.emp_disparity.desc"), icon: Employment },
        { name: t("corporate.content_pages.about_us.our_values.illegal_payments.title"), desc: t("corporate.content_pages.about_us.our_values.illegal_payments.desc"), icon: IllegalPayments },
        { name: t("corporate.content_pages.about_us.our_values.working_env.title"), desc: t("corporate.content_pages.about_us.our_values.working_env.desc"), icon: Safe },
        { name: t("corporate.content_pages.about_us.our_values.quality_oriented.title"), desc: t("corporate.content_pages.about_us.our_values.quality_oriented.desc"), icon: QualityOriented },
        { name: t("corporate.content_pages.about_us.our_values.csr.title"), desc: t("corporate.content_pages.about_us.our_values.csr.desc"), icon: CSR },
        { name: t("corporate.content_pages.about_us.our_values.mmrc_representation.title"), desc: t("corporate.content_pages.about_us.our_values.mmrc_representation.desc"), icon: Representation },
        { name: t("corporate.content_pages.about_us.our_values.corporate_holdings.title"), desc: t("corporate.content_pages.about_us.our_values.corporate_holdings.desc"), icon: Holding },
        { name: t("corporate.content_pages.about_us.our_values.code_standards.title"), desc: t("corporate.content_pages.about_us.our_values.code_standards.desc"), icon: Standards },
        { name: t("corporate.content_pages.about_us.our_values.occurring_emp.title"), desc: t("corporate.content_pages.about_us.our_values.occurring_emp.desc"), icon: OccurringEmp },
        { name: t("corporate.content_pages.about_us.our_values.data_provided.title"), desc: t("corporate.content_pages.about_us.our_values.data_provided.desc"), icon: DataProvided },
        { name: t("corporate.content_pages.about_us.our_values.adherence.title"), desc: t("corporate.content_pages.about_us.our_values.adherence.desc"), icon: Adherence },
        { name: t("corporate.content_pages.about_us.our_values.pride_repute.title"), desc: t("corporate.content_pages.about_us.our_values.pride_repute.desc"), icon: PrideRepute },
        { name: t("corporate.content_pages.about_us.our_values.security_info.title"), desc: t("corporate.content_pages.about_us.our_values.security_info.desc"), icon: Security }
    ]

    const beforeChange = (oldIndex: any, newIndex: any) => {
        setNewIdx(newIndex + 1)
    };

    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 3000,
        pauseOnHover: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    }

    return (
        <div className="bg-[#F3F3F0B2] dark:bg-[#575755] w-full">
            <div className="container gap-[25px] md:gap-[30px] xlx:gap-[40px] flex flex-col items-center justify-center xlx:!max-w-[1280px] border-b border-[#cecfcc] dark:border-[#747671] xlx:py-[65px] py-[40px]">
                <h2 className="text-primaryText dark:text-white font-bold">{t("corporate.content_pages.about_us.our_values.title")}</h2>

                <Slider className="w-full mr-[-8px] xlx:mr-[-15px]" ref={arrowRef} {...settings} beforeChange={beforeChange}>
                    {Array?.isArray(data) && data?.map((item: any, index: number) => (
                        <div className="md:pr-[15px] xlx:pr-[30px]" key={index}>
                            <div className={`bg-white dark:bg-bgDarkDull rounded-[20px] p-[20px] xsm:p-[24px] flex flex-col gap-[10px] w-full lg:w-fit h-[265px] xsm:h-[250px] md:h-[310px] mms:h-[285px] msm:h-[270px] lg:h-[310px] xl:h-[270px] xlx:h-[315px]`}>
                                {/* ${newIdx === index ? "shadow-md" : ""} ${((data?.length === newIdx) && (index === 0)) ? "shadow-md" : ""} */}
                                <item.icon className="w-[60px] h-[60px] min-w-[60px] min-h-[60px]" />
                                <div className="flex flex-col gap-[4px]">
                                    <h3 className="text-blackDark dark:text-textBlackDark font-semibold text-[19.25px] xlx:text-[22px]">{item?.name}</h3>
                                    <h5 className="font-medium text-blackDull dark:text-textBlackDull lg:max-w-[350px] xsm:line-clamp-none line-clamp-5 tracking-tight text-[14px] xlx:text-[16px] text-justify">{item?.desc}</h5>
                                </div>
                            </div>
                        </div>
                    ))}
                </Slider>

                <div className="w-full flex items-center justify-center gap-[8px] z-[1] relative">
                    <button aria-label={t("aria_label.prev_arr")}
                        title={t("aria_label.prev")} className="xlx:min-w-[39px] xlx:h-[39px] min-w-[35px] h-[35px] flex items-center justify-center rounded-full border border-[#AFAFAF] border-opacity-[0.2] dark:border-[#706f6f] dark:bg-opacity-[0.2] dark:bg-[#3b4444] bg-[#D1D1D1] bg-opacity-[0.2] focus:shadow-[0_0_0_2px_#3d3d3d5e] hover:shadow-[0_0_0_2px_#3d3d3d5e] dark:focus:shadow-[0_0_0_2px_#ffffff5e] dark:hover:shadow-[0_0_0_2px_#ffffff5e]" onClick={() => arrowRef.current.slickPrev()}>
                        <Prev className="fill-primary xlx:w-[16px] xlx:h-[14px] w-[15px] h-[13px]" />
                    </button>
                    <button aria-label={t("aria_label.next_arr")}
                        title={t("aria_label.next")} className="xlx:min-w-[39px] xlx:h-[39px] min-w-[35px] h-[35px] flex items-center justify-center rounded-full border border-[#AFAFAF] border-opacity-[0.2] dark:border-[#706f6f] dark:bg-opacity-[0.2] dark:bg-[#3b4444] bg-[#D1D1D1] bg-opacity-[0.2] focus:shadow-[0_0_0_2px_#3d3d3d5e] hover:shadow-[0_0_0_2px_#3d3d3d5e] dark:focus:shadow-[0_0_0_2px_#ffffff5e] dark:hover:shadow-[0_0_0_2px_#ffffff5e]" onClick={() => arrowRef.current.slickNext()}>
                        <Next className="fill-primary xlx:w-[16px] xlx:h-[14px] w-[15px] h-[13px]" />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DrivesUs;